import { TabItem, Tabs } from '@dixa/lib-shared-habla';
import { memo, useCallback, useMemo } from 'react';

import styles from './queueDashboardFilterControlTabs.module.scss';

export type QueueDashboardFilterControlTab = 'favourite' | 'custom';

type QueueDashboardFilterControlTabsProps = {
  tab: QueueDashboardFilterControlTab;
  onChange: (tab: QueueDashboardFilterControlTab) => void;
};

export const QueueDashboardFilterControlTabs = memo(
  function QueueDashboardFilterControlTabs({
    tab,
    onChange,
  }: QueueDashboardFilterControlTabsProps): JSX.Element {
    const tabs = useMemo(
      (): (TabItem & { id: QueueDashboardFilterControlTab })[] => [
        { id: 'favourite', label: 'Favorites', icon: 'star' },
        { id: 'custom', label: 'Queues', icon: 'search' },
      ],
      [],
    );

    const handleTabChange = useCallback(
      (value: string) => {
        onChange(value as QueueDashboardFilterControlTab);
      },
      [onChange],
    );

    return (
      <Tabs
        className={styles.tabs}
        tabClassName={styles.tab}
        selectedId={tab}
        tabs={tabs}
        onChange={handleTabChange}
      />
    );
  },
);
